import { useRef } from 'react'
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion'
import { ArrowDown, ArrowRight } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useMediaQuery } from '@/hooks/useMediaQuery'
import { HeroInboxPreview } from './HeroInboxPreview'

export function HeroScene({ fr }: { fr: boolean }) {
  const target = useRef<HTMLElement>(null)
  const reduced = useReducedMotion()
  const desktop = useMediaQuery('(min-width: 1024px)')
  const { scrollYProgress } = useScroll({ target, offset: ['start start', 'end start'] })
  const productY = useTransform(scrollYProgress, [0, 1], [0, -28])

  return <section ref={target} id="product" className="fb-product-hero">
    <motion.div className="fb-product-hero-copy" initial={reduced ? false : { y: 14 }} animate={{ y: 0 }} transition={{ duration: .65, ease: [.22, 1, .36, 1] }}>
      
      <h1 className="pt-16">{fr ? 'La plateforme centralisée' : 'One centralized platform'}<br /><span className="text-primary">{fr ? 'pour votre support client.' : 'for all your customer support.'}</span></h1>
      <p className="fb-product-hero-lead">{fr ? 'Bugs, idées et demandes d’aide dans une seule boîte de réception, avec le contexte pour répondre.' : 'Collect bugs, social mentions, ideas, and support requests in one inbox, with the context to help.'}</p>
      <div className="fb-actions">
        <Link className="fb-button" to="/auth">{fr ? 'Commencer gratuitement' : 'Start for free'} <ArrowRight size={16} /></Link>
        <a className="fb-button fb-button-outline" href="#inbox-demo">{fr ? 'Voir comment ça marche' : 'See how it works'} <ArrowDown size={15} /></a>
      </div>
      <p className="fb-fine">{fr ? 'Une offre gratuite. Sans carte bancaire.' : 'Free plan. No credit card required.'}</p>
    </motion.div>
    <motion.div id="inbox-demo" className="fb-product-hero-demo" style={desktop && !reduced ? { y: productY } : undefined}>
      <p className="fb-demo-caption">{fr ? 'Démo interactive · données fictives' : 'Interactive demo · sample data'}</p>
      <HeroInboxPreview marketingMode />
    </motion.div>
  </section>
}
